(function() {
    'use strict';

    angular
        .module('signatureApp')
        .controller('SignatureDialogController', SignatureDialogController);

    SignatureDialogController.$inject = ['$scope', '$uibModalInstance','items','$uibModal','NgTableParams','FileNetService','GLOBAL_URL'];

    function SignatureDialogController ($scope, $uibModalInstance,  items,$uibModal, NgTableParams, FileNetService,GLOBAL_URL) {
    	var signatureDlgCtrl = this;
    	
    	var data = items;
//    	console.log(data);
    	
    	signatureDlgCtrl.items = items;
    	signatureDlgCtrl.tableParams = new NgTableParams({
    	      page: 1, // show first page
    	      count: 10 // count per page
    	    }, {
    	      filterDelay: 0,
    	      dataset: data
    	    });
    	signatureDlgCtrl.showImage = function(id){
    		id = escape(id);
//    		FileNetService.get({method:'show-image',guid:id}, function(result){
    			var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : signatureDlgCtrl.animationsEnabled,
						windowClass: 'modalLv2',
						templateUrl : GLOBAL_URL+'file-net/show-image?guid='+id,
						controller : 'SignatureImgController as signatureImgDlgCtrl',
						size : 'lg',
						
						resolve : {
							id : function() {
								return id;//tranfer data for dialog
							}
						}
				});
				modalInstance.result.then(
						function(result) {
						},
						function(error){
							
						});
//    		});
    	}
    	signatureDlgCtrl.ok= ok;
    	signatureDlgCtrl.cancel= cancel;
    	signatureDlgCtrl.selected = {
//    	    item: signatureDlgCtrl.items[0].guid
    	  };

    	  function ok() {
    	    $uibModalInstance.close(signatureDlgCtrl.selected.item);
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    	  
    	  
    }
})();
